import { render, staticRenderFns } from "./plan-tabs.vue?vue&type=template&id=4be5b7e8&"
import script from "./plan-tabs.vue?vue&type=script&lang=js&"
export * from "./plan-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports